import { Button, Col, Row } from "antd";
import React, { useState } from "react";
import { WithLabel } from "../../../../types/WithLabel";
import InstallByHtml from "./component/InstallByHtml";
import InstallByPackage from "./component/InstallByPackage";

type InstallationMethod = "html" | "package";

const installationMethods: WithLabel<InstallationMethod>[] = [
  { label: "HTML", value: "html" },
  { label: "Framework", value: "package" },
];

export default function Installation() {
  const [state, setState] = useState<State>({
    selectedInstallationMethod: "html",
  });
  return (
    <Row gutter={[48, 48]}>
      <Col xs={24} lg={10}>
        <Row gutter={[48, 48]}>
          <Col xs={24}>
            <Row gutter={[0, 16]}>
              <Col xs={24}>
                <h4 className="w-font-md fw-600 center-when-mobile">
                  5 minutes setup guideline
                </h4>
              </Col>
              <Col xs={24}>
                <h2 className="color-primary center-when-mobile">
                  How to set up our vIRL marketplace widget.
                </h2>
              </Col>
              <Col
                className="w-font-md fw-600"
                style={{ color: "#777E90" }}
                xs={24}
              >
                <p className="center-when-mobile">
                  Here's a quick and easy 5-minute guide to setting up our vIRL
                  marketplace widget. With our NFT Marketplace solution, you can
                  focus on your project while we handle all the complex tasks.
                  It's the only solution you'll ever need to launch your own NFT
                  Marketplace.
                </p>
                <p style={{ marginTop: 16 }} className="center-when-mobile">
                  There's no better time than now to enter the NFT industry and
                  establish a brand that's primed for significant growth.
                </p>
              </Col>
            </Row>
          </Col>
          <Col className="center-when-mobile" xs={24}>
            <Row justify={"center"} gutter={[8, 16]}>
              <Col style={{ textAlign: "center" }}>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://github.com/worldwide-asset-exchange/wax-marketplace-widget"
                >
                  <Button type="default" size="large">
                    VIEW GITHUB
                  </Button>
                </a>
              </Col>
              <Col style={{ textAlign: "center" }}>
                <a href="/guideline">
                  <Button type="primary" size="large">
                    SEE ALL CUSTOMIZATIONS
                  </Button>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col xs={24} lg={14}>
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <Row gutter={[8, 8]}>
              {installationMethods.map((method) => (
                <Col>
                  <Button
                    type={
                      method.value === state.selectedInstallationMethod
                        ? "primary"
                        : "default"
                    }
                    onClick={() =>
                      setState({ selectedInstallationMethod: method.value })
                    }
                  >
                    {method.label}
                  </Button>
                </Col>
              ))}
            </Row>
          </Col>
          <Col xs={24}>
            {state.selectedInstallationMethod === "html" && <InstallByHtml />}
            {state.selectedInstallationMethod === "package" && (
              <InstallByPackage />
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

interface State {
  selectedInstallationMethod: InstallationMethod;
}
